import { createFileRoute } from "@tanstack/react-router";

import { NotificationsPage } from "../../features/notifications/NotificationsPage";
import { validateViewSearch } from "../../features/notifications/views";

export const Route = createFileRoute("/_app/notifications")({
  validateSearch: validateViewSearch,
  component: function Notifications() {
    return <NotificationsPage tab={Route.useSearch().tab} />;
  },
});
